module.exports = __webpack_public_path__ + "static/media/img21.dfc19010.jpg";